/* eslint-disable indent */
import React from 'react';

import i18n from 'i18';

// @mui
import { Select, MenuItem, Typography, Box } from '@mui/material';
import { AppDataContext } from '../../context/Context';
import { formatName } from '../../utils/formatName';

export default class DialogSelectField extends React.Component {
    static contextType = AppDataContext;
    render() {
        // field, value, onChange
        const translatedLabel = i18n.t(`columns.${this.props.field.label}`);
        const placeholderLabel = i18n.t(
            `placeholder.${this.props.field.label}`
        );
        const required = this.props.field.required;
        const requiredLabel = required ? ' *' : '';
        let id = this.props.field.id;
        let value = this.props.value;
        let items =
            this.context.getState().controllersData[this.props.field.from] ||
            [];

        // Filter items if itemsFilter is specified
        if (this.props.field.itemsFilter && this.props.field.from === 'roles') {
            items = items.filter((item) => {
                return this.props.field.itemsFilter.includes(item.systemRole);
            });
        }
        return (
            <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2">
                    {translatedLabel + requiredLabel}
                </Typography>
                <Select
                    margin="dense"
                    id={id}
                    name={id}
                    value={value?.id || value || ''}
                    fullWidth
                    onChange={(event) =>
                        this.props.onChange(id, event.target.value)
                    }
                    sx={{
                        '& .MuiSelect-select .notranslate::after':
                            placeholderLabel
                                ? {
                                      content: `"${placeholderLabel}"`,
                                      opacity: 0.7
                                  }
                                : {}
                    }}
                    MenuProps={{
                        PaperProps: {
                            style: {
                                maxHeight: 200
                            }
                        }
                    }}
                >
                    {items.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                            {formatName(
                                item,
                                this.props.field.display,
                                this.props.field
                            )}
                        </MenuItem>
                    ))}
                </Select>
            </Box>
        );
    }
}
